const SCHEMES = new Set(['scrambl:', 'scrambl-dev:', 'scrambl-local:'])

/** Native callbacks carry a single-use authorization code, never reusable tokens. */
export function buildNativeOAuthCallback(
  redirectUri: string,
  input: { state: string; code?: string; error?: string },
): string {
  const url = new URL(redirectUri)
  if (
    !SCHEMES.has(url.protocol) ||
    url.hostname !== 'auth' ||
    url.pathname !== '/callback' ||
    url.username ||
    url.password ||
    url.port ||
    url.search ||
    url.hash ||
    !input.state ||
    input.state.length > 4096 ||
    (!input.code && !input.error) ||
    (input.code && input.error)
  )
    throw new Error('Invalid native sign-in callback.')
  url.searchParams.set('state', input.state)
  if (input.code) url.searchParams.set('code', input.code)
  else url.searchParams.set('error', 'sign_in_failed')
  return url.toString()
}

export function readNativeOAuthCallback(
  value: string,
  scheme?: string,
): { state: string; code?: string; error?: string } | null {
  try {
    const url = new URL(value)
    if (
      !SCHEMES.has(url.protocol) ||
      (scheme && url.protocol !== `${scheme}:`) ||
      url.hostname !== 'auth' ||
      url.pathname !== '/callback' ||
      url.username ||
      url.password ||
      url.port ||
      url.hash ||
      ['state', 'code', 'error'].some(
        key => url.searchParams.getAll(key).length > 1,
      ) ||
      ['accessToken', 'refreshToken', 'idToken', 'codeVerifier'].some(key =>
        url.searchParams.has(key),
      )
    )
      return null
    const state = url.searchParams.get('state'),
      code = url.searchParams.get('code') ?? undefined,
      error = url.searchParams.get('error') ?? undefined
    if (
      !state ||
      state.length > 4096 ||
      (!code && !error) ||
      (code && error) ||
      (code && code.length > 4096)
    )
      return null
    return { state, code, error }
  } catch {
    return null
  }
}
